import api from "./api";

export const postComment = async (body: any) => {
    const response = await api.post(`comments/`, body);
    return response.data;
};

export const getCommentsAll = async (idPlant: any) => {
    const response = await api.get(`comments/listAll?idPlant=${idPlant ? idPlant : ""}`);
    return response.data;
};

export const deleteCommentOne = async(id: string) => {
    const response = await api.delete(`comments/${id}`);
    return response.data;
};

export const getCommentsService = async (idService: string) => {
    const response = await api.get(`comments/listAll?idService=${idService ? idService : ""}`);
    return response.data;
};
